import { render, staticRenderFns } from "./LibraryResourceBook.vue?vue&type=template&id=fddc9bc4&"
import script from "./LibraryResourceBook.vue?vue&type=script&lang=js&"
export * from "./LibraryResourceBook.vue?vue&type=script&lang=js&"
import style0 from "./LibraryResourceBook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports